module.exports = __webpack_public_path__ + "img/D202211_1.36c8b9ca.jpg";